<div class="or-h-80-px">
  @if (isAuthed()) {
    @if (isMyGame()) {
      <ng-container *ngTemplateOutlet="divider"></ng-container>
      <button (click)="redirectToHostedGameDetails()" class="button-primary-style or-h-48-px or-w-100-pc or-head-md">
        Sprawdź szczegóły gierki
      </button>
    }
    @if (showJoinButton()) {
      <ng-container *ngTemplateOutlet="divider"></ng-container>
      <button
        preventMultiClick
        class="button-primary-style or-h-48-px or-w-100-pc or-head-md"
        [sendApplication]="game().gameId"
        (applicationSent)="applicationSentEvent($event)">
        Dołącz do gierki!
      </button>
    }
    @if (showWaitingButton()) {
      <ng-container *ngTemplateOutlet="divider"></ng-container>
      <button class="button-primary-style or-h-48-px or-w-100-pc or-head-md disabled-button">
        Czekasz na zatwierdzenie
      </button>
    }
    @if (showJoinedButton()) {
      <ng-container *ngTemplateOutlet="divider"></ng-container>
      <button (click)="redirectToGameDetails()" class="button-primary-style or-h-48-px or-w-100-pc or-head-md">
        Sprawdź szczegóły gierki
      </button>
    }
  } @else {
    <ng-container *ngTemplateOutlet="divider"></ng-container>
    <button class="button-primary-style or-h-48-px or-w-100-pc or-head-md" (click)="redirectToAuth()">
      Zaloguj się i dołącz do gierki!
    </button>
  }

  <ng-template #divider>
    <div class="or-d-flex or-justify-content-center">
      <div class="custom-divider or-my-16-px"></div>
    </div>
  </ng-template>
</div>
